unit LokacijaIzbor;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Web, System.Dateutils,
  Vcl.Graphics, Vcl.Controls, Vcl.Forms, Vcl.Dialogs, Vcl.StdCtrls, TerminalForm,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Controls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Forms,
  XData.Web.Connection, Vcl.Grids, WEBLib.Buttons, WEBLib.WebCtrls;

type
  TfrmLokacijaIzbor = class(TTerminalForm)
    tmrFind: TTimer;
    wdsLokacije: TXDataWebDataSet;
    dsLokacije: TDataSource;
    panHeader: TPanel;
    edtFilter: TEdit;
    panFooter: TPanel;
    btnSelect: TButton;
    gridView: TDBGrid;
    btnDelNote: TButton;
    lblIsci: TLabel;
    mapMain: TGoogleMaps;
    btnLocate: TButton;
    btnMap: TButton;
    splitMap: TSplitter;
    btnClose: TButton;
    tmrPoz: TTimer;
    procedure tmrFindTimer(Sender: TObject);
    procedure edtFilterChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure wdsLokacijeAfterOpen(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
    procedure btnDelNoteClick(Sender: TObject);
    procedure btnLocate2Click(Sender: TObject);
    procedure ToggleLocate(Value, Silent: boolean);
    procedure btnMapClick(Sender: TObject);
    procedure mapMainMapLoaded(Sender: TObject);
    procedure mapMainMapZoom(Sender: TObject; ZoomLevel: Integer);
    procedure mapMainMarkerClick(Sender: TObject; AIndex: Integer; AMarker: TJSObjectRecord);
    procedure ProcesirajLokacijo;
    procedure btnCloseClick(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);  // Klic pride iz frmMain
  private
    { Private declarations }
    Starting: boolean;
    datToday: string;
    CurLatD, CurLatL, CurLonL, CurLonD: double;
    sCurLatD, sCurLatL, sCurLonL, sCurLonD: string;

    procedure VrniLokacije(Flt, Srt: string);
    function VrniPozicijo(LatLon: double; PremikM: integer): double;
    procedure ToggleButtons;
    procedure CustomizeGui;
    procedure ApplyTheme; reintroduce;
    function LocationEnabled: boolean;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses Client.Core, Main, Client.Settings, Client.Constants;

procedure TfrmLokacijaIzbor.ApplyTheme;
begin
  inherited;
end;

procedure TfrmLokacijaIzbor.btnDelNoteClick(Sender: TObject);
begin
  edtFilter.Clear;
  edtFilter.SetFocus;
  tmrFindTimer(Sender)
end;

procedure TfrmLokacijaIzbor.btnLocate2Click(Sender: TObject);
begin
  modMain.GeoLocationEnabled := not modMain.GeoLocationEnabled;  // Uporabi geolokacijo?

  tmrPoz.Tag := 1;   // 1 - prvi zagon

  ToggleLocate(LocationEnabled, false);
  tmrFindTimer(Sender);

  // GPS požene refresh
  tmrPoz.Interval := 1000 * modMain.AppSettings.LocationInterval;
  tmrPoz.Enabled := LocationEnabled;
end;

function TfrmLokacijaIzbor.LocationEnabled: boolean;
begin
  Result := modMain.GeoLocationEnabled;
end;

procedure TfrmLokacijaIzbor.ToggleButtons;
begin
  btnSelect.Enabled := wdsLokacije.RecordCount > 0;
  btnClose.Enabled := true;
end;

procedure TfrmLokacijaIzbor.ToggleLocate(Value, Silent: boolean);
begin
  if Value then begin
    btnLocate.ElementClassName := 'btn btn-xxl btn-warning';
  end else begin
    btnLocate.ElementClassName := 'btn btn-xxl btn-primary';
  end;
  btnMap.Enabled := Value;

  // Skije mapo, če ni GPS
  if not Value and mapMain.Visible then
    mapMain.Visible := false;
end;

procedure TfrmLokacijaIzbor.edtFilterChange(Sender: TObject);
begin
  tmrFind.Enabled := false;
  tmrFind.Enabled := true;
end;

procedure TfrmLokacijaIzbor.tmrFindTimer(Sender: TObject);
var Flt, Srt: string;
    F: TStringList;

  function Filter(FL: TStringList): string;
  var I: integer;
  begin
    Result := '';
    for I := 0 to FL.Count-1 do begin
      if I > 0 then
        Result := Result + ' and ';

      Result := Result + FL[I];
    end;
  end;

begin
  tmrFind.Enabled := false;

  if (Sender=tmrPoz) and (not LocationEnabled) and (edtFilter.Text='') then begin
    Console.Log('LocationEnabled = false -> skip refresh');
    exit;
  end;

  Flt := '';
  Srt := 'stranka/naziv,naziv';

  F := TStringList.Create;

  // Omeji glede na lokacijo
  ProcesirajLokacijo;
  if LocationEnabled and (CurLatL<>0) and (edtFilter.Text='')  then begin
    if not modMain.HasMoved and not Starting and (tmrPoz.Tag = 0) then begin
      modMain.Log('No movement, quit refresh...');
      exit;
    end;
    modMain.Log('Using location...');
    F.Add('lat gt '+sCurLatL+' and lat lt '+sCurLatD+' and lon gt '+sCurLonL+' and lon lt '+sCurLonD+'');
  end;

  tmrPoz.Tag := 0; // Reset taga po meni, da ni prvi zagon in upošteva delto

  // Uporabniški filter
  if edtFilter.Text<>'' then begin
    F.Add('(contains(stranka/naziv,%27'+edtFilter.Text+'%27) or contains(naziv,%27'+edtFilter.Text+'%27) or contains(opombe,%27'+edtFilter.Text+'%27))');
  end;

  Flt := Filter(F);
  F.Free;

  VrniLokacije(Flt, Srt);
end;

// Klic pride iz frmMain
procedure TfrmLokacijaIzbor.ProcesirajLokacijo;
begin
  if not LocationEnabled then
    exit;

  // Vrne kote kvadrata +- 100m od točke
  CurLatL := VrniPozicijo(modMain.LokacijaLat, 0-modMain.AppSettings.LocationLength);
  CurLatD := VrniPozicijo(modMain.LokacijaLat, modMain.AppSettings.LocationLength);

  CurLonL := VrniPozicijo(modMain.LokacijaLon, 0-modMain.AppSettings.LocationLength) ;
  CurLonD := VrniPozicijo(modMain.LokacijaLon, modMain.AppSettings.LocationLength);

  sCurLatL := CurLatL.ToString.Replace(',', '.');
  sCurLatD := CurLatD.ToString.Replace(',', '.');
  sCurLonL := CurLonL.ToString.Replace(',', '.');
  sCurLonD := CurLonD.ToString.Replace(',', '.');
end;

procedure TfrmLokacijaIzbor.mapMainMapLoaded(Sender: TObject);
begin
  CustomizeGui;
  mapMain.SetZoom(modMain.AppSettings.DefaultZoom);
  if modMain.LokacijaLat=0 then
    mapMain.SetCenter(modMain.AppSettings.DefaultLat, modMain.AppSettings.DefaultLon)
  else
    mapMain.SetCenter(modMain.LokacijaLat, modMain.LokacijaLon);
end;

procedure TfrmLokacijaIzbor.mapMainMapZoom(Sender: TObject; ZoomLevel: Integer);
begin
  modMain.AppSettings.DefaultZoom := ZoomLevel;
end;

procedure TfrmLokacijaIzbor.mapMainMarkerClick(Sender: TObject; AIndex: Integer;
  AMarker: TJSObjectRecord);
begin
  if (AIndex>0) and (AIndex < wdslokacije.RecordCount) then begin
    modMain.Log('Settings RecNo...');
    wdsLokacije.RecNo := AIndex;
  end;
end;

procedure TfrmLokacijaIzbor.VrniLokacije(Flt, Srt: string);
var Qry: string;
begin
  if Flt<>'' then
    Flt := Flt + ' and ';

  Flt := Flt + 'aktivna eq 1 and stranka/aktivna eq 1';
  Qry := '$filter='+Flt+'&$orderby='+Srt+'&$expand=stranka';

//  modMain.Log('Qry='+Qry);

  wdsLokacije.Close;
  wdsLokacije.QueryString := Qry;
  wdsLokacije.Load;
end;

function TfrmLokacijaIzbor.VrniPozicijo(LatLon: double; PremikM: integer): double;
var earth: double;
    pi: double;
    m: double;
begin
  earth := 6378.137;  // radij zemlje v km

  asm
    pi = Math.PI;
  end;

  m := (1 / ((2 * pi / 360) * earth)) / 1000;  // 1 meter v stopinjah

  Result := LatLon + (PremikM * m);
end;

procedure TfrmLokacijaIzbor.wdsLokacijeAfterOpen(DataSet: TDataSet);
var poz: integer;
    vozilo, title: string;
begin
  ToggleButtons;

  {$REGION 'Risanje zemljevida'}
  if mapMain.Visible then begin
    modMain.log('Updating map...');
    mapMain.BeginUpdate;
    wdsLokacije.DisableControls;
    poz := wdsLokacije.RecNo;
    wdsLokacije.First;

    mapMain.ClearRectangles;
    mapMain.AddRectangle(CurLatL, CurLonL, CurLatD, CurLonD, clInfoBk, 0, 2, 0.3);
    vozilo := 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANZJREFUSEvtlNENAiEQRIdOtBOtRK1ErUQ70U60E71JmAs5ISMEfoz7d8cyj90dCBgcYbA+fgewAXABsGpsWbETWrgBIKQ1LOAVlWtnYvdJ0CYWSrP7egFS/gnAWT9GAJ4ADtNM74T0AkjnOImyAkLWIwC0Oe1OR15ZSe8KeGhCHnJlL0Dp/oQcIO0jy5wdkVGRTb8GtN7kasA2OkG9dOBS/twiCehNoo9pNX7TzxTIhc1fvj37aLNUjDDOIhc2fwmgxejhXbSbG7LNr3093Sw+1v8A27I3Nx01GW789uAAAAAASUVORK5CYII=';

    mapMain.ClearMarkers;
    // Vozilo
    mapMain.AddMarker(modMain.LokacijaLat, modMain.LokacijaLon, vozilo, 'To si ti', 0, 0);
    // Lokacije
    while not wdsLokacije.Eof do begin
      title := wdsLokacije.FieldByName('Stranka.Naziv').AsString+', '+wdsLokacije.FieldByName('Naziv').AsString;
      mapMain.AddMarker(wdsLokacije.FieldByName('Lat').Asfloat, wdsLokacije.FieldByName('Lon').Asfloat, Title);
      wdsLokacije.Next;
    end;

    if poz>0 then begin
      wdsLokacije.RecNo := poz;
    end;
    wdsLokacije.EnableControls;
    mapMain.EndUpdate;
    mapMain.SetCenter(modMain.LokacijaLat, modMain.LokacijaLon);
  end;
  {$ENDREGION}

  Starting := false;
end;

procedure TfrmLokacijaIzbor.btnMapClick(Sender: TObject);
begin
  mapMain.Visible := not mapMain.Visible;
  splitMap.Visible := mapMain.Visible;
end;

procedure TfrmLokacijaIzbor.btnSelectClick(Sender: TObject);
begin
  inherited;

  modMain.NastaviLokacijo(wdsLokacije.FieldByName('Id').AsInteger, wdsLokacije.FieldByName('Stranka.Id').AsInteger, Ord(ooNone));
  modMain.PredlogPranje(modMain.LokacijaId, modMain.VoziloId, Ord(npsOdobren), '');

  frmmain.ShowNalogiPranje;
end;

procedure TfrmLokacijaIzbor.btnCloseClick(Sender: TObject);
begin
  inherited;
  frmmain.ShowNalogiPranje;
end;

procedure TfrmLokacijaIzbor.WebFormCreate(Sender: TObject);
begin
  inherited;
  Starting := true;

  datToday := DateToStr(modMain.IzbranDatum, Fmt);

  ToggleLocate(LocationEnabled, true);
  tmrFindTimer(nil);

  modMain.Log('Fmt='+Fmt.ShortDateFormat);
end;

procedure TfrmLokacijaIzbor.WebFormShow(Sender: TObject);
begin
  inherited;

  gridView.ColWidths[0] := Round(frmMain.Width * 0.5)-10;
  gridView.ColWidths[1] := Round(frmMain.Width * 0.5)-10;

  ApplyTheme;
end;

procedure TfrmLokacijaIzbor.CustomizeGui;
var map: TJSHTMLElement;
begin
  map := mapMain.MapElement;
  if Assigned(map) then begin
    asm
      map.setOptions({disableDefaultUI:true});
    end;
  end;
end;

procedure TfrmLokacijaIzbor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panHeader := TPanel.Create(Self);
  lblIsci := TLabel.Create(Self);
  edtFilter := TEdit.Create(Self);
  btnDelNote := TButton.Create(Self);
  btnLocate := TButton.Create(Self);
  btnMap := TButton.Create(Self);
  panFooter := TPanel.Create(Self);
  btnSelect := TButton.Create(Self);
  btnClose := TButton.Create(Self);
  gridView := TDBGrid.Create(Self);
  mapMain := TGoogleMaps.Create(Self);
  splitMap := TSplitter.Create(Self);
  tmrFind := TTimer.Create(Self);
  wdsLokacije := TXDataWebDataSet.Create(Self);
  dsLokacije := TDataSource.Create(Self);
  tmrPoz := TTimer.Create(Self);

  panHeader.BeforeLoadDFMValues;
  lblIsci.BeforeLoadDFMValues;
  edtFilter.BeforeLoadDFMValues;
  btnDelNote.BeforeLoadDFMValues;
  btnLocate.BeforeLoadDFMValues;
  btnMap.BeforeLoadDFMValues;
  panFooter.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  gridView.BeforeLoadDFMValues;
  mapMain.BeforeLoadDFMValues;
  splitMap.BeforeLoadDFMValues;
  tmrFind.BeforeLoadDFMValues;
  wdsLokacije.BeforeLoadDFMValues;
  dsLokacije.BeforeLoadDFMValues;
  tmrPoz.BeforeLoadDFMValues;
  try
    Name := 'frmLokacijaIzbor';
    Left := 0;
    Top := 0;
    Align := alClient;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    panHeader.SetParentComponent(Self);
    panHeader.Name := 'panHeader';
    panHeader.Left := 0;
    panHeader.Top := 0;
    panHeader.Width := 831;
    panHeader.Height := 91;
    panHeader.Align := alTop;
    panHeader.BorderStyle := bsNone;
    panHeader.ChildOrder := 3;
    panHeader.Color := clWhite;
    panHeader.ElementBodyClassName := 'text';
    panHeader.Padding.Left := 5;
    panHeader.Padding.Top := 5;
    panHeader.Padding.Right := 5;
    panHeader.Padding.Bottom := 5;
    panHeader.TabOrder := 1;
    lblIsci.SetParentComponent(panHeader);
    lblIsci.Name := 'lblIsci';
    lblIsci.Left := 5;
    lblIsci.Top := 5;
    lblIsci.Width := 60;
    lblIsci.Height := 81;
    lblIsci.Align := alLeft;
    lblIsci.AutoSize := False;
    lblIsci.Caption := 'I'#353#269'i';
    lblIsci.ElementClassName := 'fs-1';
    lblIsci.ElementFont := efCSS;
    lblIsci.Font.Charset := DEFAULT_CHARSET;
    lblIsci.Font.Color := clWindowText;
    lblIsci.Font.Height := -21;
    lblIsci.Font.Name := 'Tahoma';
    lblIsci.Font.Style := [];
    lblIsci.HeightPercent := 100.000000000000000000;
    lblIsci.Layout := tlCenter;
    lblIsci.ParentFont := False;
    lblIsci.WidthPercent := 100.000000000000000000;
    edtFilter.SetParentComponent(panHeader);
    edtFilter.Name := 'edtFilter';
    edtFilter.AlignWithMargins := True;
    edtFilter.Left := 68;
    edtFilter.Top := 10;
    edtFilter.Width := 476;
    edtFilter.Height := 71;
    edtFilter.Margins.Top := 5;
    edtFilter.Margins.Bottom := 5;
    edtFilter.Align := alClient;
    edtFilter.CharCase := wecUpperCase;
    edtFilter.ChildOrder := 3;
    edtFilter.EditType := weSearch;
    edtFilter.ElementClassName := 'fs-1';
    edtFilter.ElementFont := efCSS;
    edtFilter.HeightPercent := 100.000000000000000000;
    edtFilter.RequiredText := 'I'#353#269'i...';
    edtFilter.WidthPercent := 100.000000000000000000;
    SetEvent(edtFilter, Self, 'OnChange', 'edtFilterChange');
    btnDelNote.SetParentComponent(panHeader);
    btnDelNote.Name := 'btnDelNote';
    btnDelNote.AlignWithMargins := True;
    btnDelNote.Left := 550;
    btnDelNote.Top := 8;
    btnDelNote.Width := 80;
    btnDelNote.Height := 75;
    btnDelNote.Margins.Right := 10;
    btnDelNote.Align := alRight;
    btnDelNote.Caption := '<i class="material-icons">backspace</i>';
    btnDelNote.ChildOrder := 2;
    btnDelNote.ElementClassName := 'btn btn-xxl btn-primary';
    btnDelNote.ElementFont := efCSS;
    btnDelNote.HeightPercent := 100.000000000000000000;
    btnDelNote.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelNote, Self, 'OnClick', 'btnDelNoteClick');
    btnLocate.SetParentComponent(panHeader);
    btnLocate.Name := 'btnLocate';
    btnLocate.AlignWithMargins := True;
    btnLocate.Left := 643;
    btnLocate.Top := 8;
    btnLocate.Width := 80;
    btnLocate.Height := 75;
    btnLocate.Margins.Right := 10;
    btnLocate.Align := alRight;
    btnLocate.Caption := '<i class="material-icons">my_location</i>';
    btnLocate.ChildOrder := 2;
    btnLocate.ElementClassName := 'btn btn-primary';
    btnLocate.ElementFont := efCSS;
    btnLocate.HeightPercent := 100.000000000000000000;
    btnLocate.WidthPercent := 100.000000000000000000;
    SetEvent(btnLocate, Self, 'OnClick', 'btnLocate2Click');
    btnMap.SetParentComponent(panHeader);
    btnMap.Name := 'btnMap';
    btnMap.AlignWithMargins := True;
    btnMap.Left := 736;
    btnMap.Top := 8;
    btnMap.Width := 80;
    btnMap.Height := 75;
    btnMap.Margins.Right := 10;
    btnMap.Align := alRight;
    btnMap.Caption := '<i class="material-icons">map</i>';
    btnMap.ChildOrder := 2;
    btnMap.ElementClassName := 'btn btn-primary';
    btnMap.ElementFont := efCSS;
    btnMap.HeightPercent := 100.000000000000000000;
    btnMap.Visible := False;
    btnMap.WidthPercent := 100.000000000000000000;
    SetEvent(btnMap, Self, 'OnClick', 'btnMapClick');
    panFooter.SetParentComponent(Self);
    panFooter.Name := 'panFooter';
    panFooter.Left := 0;
    panFooter.Top := 706;
    panFooter.Width := 831;
    panFooter.Height := 120;
    panFooter.Align := alBottom;
    panFooter.BorderStyle := bsNone;
    panFooter.ChildOrder := 3;
    panFooter.Color := clWhite;
    panFooter.Padding.Top := 4;
    panFooter.TabOrder := 2;
    btnSelect.SetParentComponent(panFooter);
    btnSelect.Name := 'btnSelect';
    btnSelect.AlignWithMargins := True;
    btnSelect.Left := 716;
    btnSelect.Top := 9;
    btnSelect.Width := 105;
    btnSelect.Height := 108;
    btnSelect.Margins.Top := 5;
    btnSelect.Margins.Right := 10;
    btnSelect.Align := alRight;
    btnSelect.Caption := '<i class="material-icons" style="font-size:40px;">done</i>';
    btnSelect.ChildOrder := 1;
    btnSelect.ElementClassName := 'btn btn-xxl btn-success';
    btnSelect.ElementFont := efCSS;
    btnSelect.Enabled := False;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    btnClose.SetParentComponent(panFooter);
    btnClose.Name := 'btnClose';
    btnClose.AlignWithMargins := True;
    btnClose.Left := 3;
    btnClose.Top := 9;
    btnClose.Width := 105;
    btnClose.Height := 108;
    btnClose.Margins.Top := 5;
    btnClose.Margins.Right := 10;
    btnClose.Align := alLeft;
    btnClose.Caption := '<i class="material-icons" style="font-size:40px;">close</i>';
    btnClose.ChildOrder := 1;
    btnClose.ElementClassName := 'btn btn-danger';
    btnClose.ElementFont := efCSS;
    btnClose.Enabled := False;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    gridView.SetParentComponent(Self);
    gridView.Name := 'gridView';
    gridView.Left := 0;
    gridView.Top := 91;
    gridView.Width := 831;
    gridView.Height := 361;
    gridView.Align := alClient;
    gridView.Color := clWhite;
    gridView.Columns.Clear;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'text-wrap';
      DataField := 'Stranka.Naziv';
      Title := 'Stranka';
      Width := 330;
    end;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'text-wrap';
      DataField := 'Naziv';
      Title := 'Lokacija';
      Width := 340;
    end;
    gridView.DataSource := dsLokacije;
    gridView.ElementFont := efCSS;
    gridView.ElementClassName := 'fs-2';
    gridView.FixedFont.Charset := DEFAULT_CHARSET;
    gridView.FixedFont.Color := clWindowText;
    gridView.FixedFont.Height := -12;
    gridView.FixedFont.Name := 'Segoe UI';
    gridView.FixedFont.Style := [];
    gridView.FixedCols := 0;
    gridView.FixedRows := 0;
    gridView.Font.Charset := DEFAULT_CHARSET;
    gridView.Font.Color := clWindowText;
    gridView.Font.Height := -48;
    gridView.Font.Name := 'Tahoma';
    gridView.Font.Style := [];
    gridView.Options := [goHorzLine,goRowSelect];
    gridView.ParentFont := False;
    gridView.TabOrder := 0;
    gridView.HeightPercent := 100.000000000000000000;
    gridView.ShowIndicator := False;
    gridView.WidthPercent := 100.000000000000000000;
    gridView.ColWidths[0] := 330;
    gridView.ColWidths[1] := 340;
    mapMain.SetParentComponent(Self);
    mapMain.Name := 'mapMain';
    mapMain.Left := 0;
    mapMain.Top := 457;
    mapMain.Width := 831;
    mapMain.Height := 249;
    mapMain.Align := alBottom;
    mapMain.APIKey := 'AIzaSyAvcd34ShYOvU1IFBq4JAJ2an032gl3MFo';
    mapMain.ChildOrder := 4;
    mapMain.Options.DefaultLatitude := -34.397000000000000000;
    mapMain.Options.DefaultLongitude := 150.644000000000000000;
    mapMain.Visible := False;
    SetEvent(mapMain, Self, 'OnMapLoaded', 'mapMainMapLoaded');
    SetEvent(mapMain, Self, 'OnMapZoom', 'mapMainMapZoom');
    SetEvent(mapMain, Self, 'OnMarkerClick', 'mapMainMarkerClick');
    splitMap.SetParentComponent(Self);
    splitMap.Name := 'splitMap';
    splitMap.Left := 0;
    splitMap.Top := 452;
    splitMap.Width := 831;
    splitMap.Height := 5;
    splitMap.Align := alBottom;
    splitMap.ChildOrder := 4;
    splitMap.Color := clBtnFace;
    splitMap.Visible := False;
    tmrFind.SetParentComponent(Self);
    tmrFind.Name := 'tmrFind';
    tmrFind.Enabled := False;
    tmrFind.Interval := 500;
    SetEvent(tmrFind, Self, 'OnTimer', 'tmrFindTimer');
    tmrFind.Left := 100;
    tmrFind.Top := 144;
    wdsLokacije.SetParentComponent(Self);
    wdsLokacije.Name := 'wdsLokacije';
    wdsLokacije.AfterOpen := wdsLokacijeAfterOpen;
    wdsLokacije.EntitySetName := 'Lokacija';
    wdsLokacije.Connection := modMain.connServer;
    wdsLokacije.SubpropsDepth := 2;
    wdsLokacije.Left := 104;
    wdsLokacije.Top := 216;
    dsLokacije.SetParentComponent(Self);
    dsLokacije.Name := 'dsLokacije';
    dsLokacije.DataSet := wdsLokacije;
    dsLokacije.Left := 104;
    dsLokacije.Top := 272;
    tmrPoz.SetParentComponent(Self);
    tmrPoz.Name := 'tmrPoz';
    tmrPoz.Interval := 10000;
    SetEvent(tmrPoz, Self, 'OnTimer', 'tmrFindTimer');
    tmrPoz.Left := 192;
    tmrPoz.Top := 144;
  finally
    panHeader.AfterLoadDFMValues;
    lblIsci.AfterLoadDFMValues;
    edtFilter.AfterLoadDFMValues;
    btnDelNote.AfterLoadDFMValues;
    btnLocate.AfterLoadDFMValues;
    btnMap.AfterLoadDFMValues;
    panFooter.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    gridView.AfterLoadDFMValues;
    mapMain.AfterLoadDFMValues;
    splitMap.AfterLoadDFMValues;
    tmrFind.AfterLoadDFMValues;
    wdsLokacije.AfterLoadDFMValues;
    dsLokacije.AfterLoadDFMValues;
    tmrPoz.AfterLoadDFMValues;
  end;
end;

end.
